import client from './client';

export const login = async (email, password) => {
  const res = await client.post('/api/auth/login', { email, password });
  return res.data;
};

export const register = async (data) => {
  const res = await client.post('/api/auth/register', data);
  return res.data;
};

export const getMe = async () => {
  const res = await client.get('/api/auth/me');
  return res.data;
};

export const logout = async () => {
  const res = await client.post('/api/auth/logout');
  return res.data;
};

export const resendVerification = async (email) => {
  const res = await client.post('/api/auth/resend-verification', { email });
  return res.data;
};

export const changePassword = async (oldPassword, newPassword) => {
  const res = await client.put('/api/auth/change-password', { oldPassword, newPassword });
  return res.data;
};
